<template lang="pug">
  span.performance-entry(@keydown.esc="close" @focusout="leave")
    a(href="/member/performance-search" :aria-disabled="busy" :aria-busy="busy" @click.prevent="!busy && $emit('open')") 業績查詢
    button(v-if="legacy" ref="toggle" type="button" aria-label="展開原版業績查詢" :aria-expanded="expanded ? 'true' : 'false'" @click="expanded = !expanded") ▾
    a.legacy-entry(v-if="legacy && expanded" href="/member/performance-search" @click="expanded = false") 原版業績查詢
</template>
<script>
export default {
  props: { busy: Boolean, legacy: Boolean, version: Number },
  data: () => ({ expanded: false }),
  watch: { version () { this.expanded = false }, legacy () { this.expanded = false }, busy (value) { if (value) this.expanded = false } },
  mounted () { document.addEventListener('click', this.outside) },
  beforeDestroy () { document.removeEventListener('click', this.outside) },
  methods: {
    outside (e) { if (!this.$el.contains(e.target)) this.expanded = false },
    leave (e) { if (!this.$el.contains(e.relatedTarget)) this.expanded = false },
    close () { this.expanded = false; this.$refs.toggle?.focus() }
  }
}
</script>
<style scoped>
.performance-entry{position:relative;display:inline-flex;align-items:center;flex-wrap:nowrap;color:inherit;white-space:nowrap}
.performance-entry>a{min-height:44px;display:inline-flex;align-items:center;color:inherit}
.performance-entry>button{min-width:44px;min-height:44px;border:0;background:transparent;color:inherit;font-size:20px}
.legacy-entry{position:absolute;right:0;top:100%;background:white;color:#007b3c!important;border:1px solid #ddd;padding:12px;min-width:150px;z-index:1000;white-space:nowrap;box-shadow:0 4px 12px #0000001a}
@media(max-width:767px){.performance-entry{max-width:100%}}
</style>
